export interface LineConfig {
  id?: string;
  centerGroupId?: number;
  isActive: boolean;
  channelId: string;
  channelSecret: string;
  channelAccessToken: string;
  webhookUrl?: string | null;
  friendAddBaseUrl?: string | null;
  createdAt?: string;
  updatedAt?: string | null;
}

export interface LineCreateRequest {
  channelId: string;
  channelSecret: string;
  channelAccessToken: string;
  webhookUrl?: string | null;
  friendAddBaseUrl?: string | null;
}

export interface LineUpdateRequest {
  channelId?: string;
  channelSecret?: string | null;
  channelAccessToken?: string | null;
  webhookUrl?: string | null;
  friendAddBaseUrl?: string | null;
  isActive?: boolean;
}

export interface LineTestResponse {
  success: boolean;
  message: string;
  testedAt?: string;
}
